import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ENDORSEMENT_STATUS } from '_/utils/constants';
import { NewDownload } from '@plataforma/components/src/components/Icons';
import { PROCESS_STATUS } from '@plataforma/utils';
import * as S from './EndorsementItemStyles';

function EndorsementItem({
  documentNumber,
  policyNumber,
  createdAt,
  typeDescription,
  hasOpenedQuestion,
  onClickAnswerQuestion,
  onClickRequestEmission,
  statusDescription,
  internalized,
  status,
  hasOpenedQuestionDescription,
  onClickDownloadPolicy,
  policyStatus
}) {
  const { t } = useTranslation();

  function getActionButton() {
    if (policyStatus.id !== PROCESS_STATUS.quoteCanceled.id) {
      if (hasOpenedQuestion) {
        return (
          <S.ActionButton
            data-testid="has-opened-question"
            variant="primary"
            size="small"
            onClick={onClickAnswerQuestion}
          >
            {t('policyDetail.questionButtonLabel')}
          </S.ActionButton>
        );
      }
      if (status === ENDORSEMENT_STATUS.requestEmission) {
        return (
          <S.ActionButton
            data-testid="request-emission"
            variant="primary"
            size="small"
            onClick={onClickRequestEmission}
          >
            {t('policyDetail.requestEmissionButtonLabel')}
          </S.ActionButton>
        );
      }
    }
    return null;
  }

  return (
    <S.Wrapper data-testid="endorsement-card">
      <S.Container key={documentNumber}>
        <S.EndorsementIcon />
        <S.Group>
          <S.DocumentNumber>
            {status === ENDORSEMENT_STATUS.emmited ||
            status === ENDORSEMENT_STATUS.canceled
              ? policyNumber
              : documentNumber}
          </S.DocumentNumber>
          <S.Date>
            {`${t('policyDetail.endorsementDateLabel')} ${createdAt}`}
          </S.Date>
          <S.Description>{typeDescription}</S.Description>
        </S.Group>
        {status === ENDORSEMENT_STATUS.emmited && (
          <S.DownloadButton
            onClick={e => {
              e.stopPropagation();
              onClickDownloadPolicy(documentNumber);
            }}
          >
            <NewDownload />
            <S.labelButtonDownload>Baixar apólice</S.labelButtonDownload>
          </S.DownloadButton>
        )}
        {getActionButton()}
      </S.Container>
      {(internalized || status === ENDORSEMENT_STATUS.requestEmission) && (
        <S.Warning
          internalized={internalized && status !== ENDORSEMENT_STATUS.emmited}
        >
          <S.WarningText>
            {t(
              `endorsementStatus.${statusDescription}.${hasOpenedQuestionDescription ||
                'default'}`
            )}
          </S.WarningText>
        </S.Warning>
      )}
    </S.Wrapper>
  );
}

EndorsementItem.propTypes = {
  documentNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  policyNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  createdAt: PropTypes.string.isRequired,
  typeDescription: PropTypes.string.isRequired,
  onClickAnswerQuestion: PropTypes.func,
  onClickRequestEmission: PropTypes.func,
  statusDescription: PropTypes.string,
  hasOpenedQuestionDescription: PropTypes.string,
  hasOpenedQuestion: PropTypes.bool,
  internalized: PropTypes.bool,
  status: PropTypes.number,
  onClickDownloadPolicy: PropTypes.func,
  policyStatus: PropTypes.string
};

export default memo(EndorsementItem);
